import { useCurrentBox } from "@modules/box/useBox"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import { useToast } from "@modules/ui/components/huToast"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useRefundTransaction = () => {
  const { userFinanceApi, boxFinanceApi } = useServicesContext()
  const { result: boxId } = useCurrentBox()
  const toast = useToast()
  const queryClient = useQueryClient()

  const financeApi = boxId ? boxFinanceApi : userFinanceApi
  const apiKey = boxId ? "boxTransactionDetails" : "userTransactionDetails"

  const { mutateAsync: refundTransaction, isPending } = useMutation({
    mutationFn: async (transactionId: string) => {
      await financeApi.refundTransaction(transactionId)
      return transactionId
    },
    onSuccess: (transactionId: string) => {
      toast.show({
        severity: "success",
        content: word("box.transaction.refund.modal.toast.success"),
      })

      queryClient.invalidateQueries({
        queryKey: [apiKey, transactionId],
      })
    },
    onError: () => {
      toast.show({
        severity: "error",
        content: word("box.transaction.refund.modal.toast.error"),
      })
    },
  })

  return {
    refundTransaction,
    isPending,
  }
}
